export * from './contact.model';
export * from './contact-popup.service';
export * from './contact.service';
export * from './contact-dialog.component';
export * from './contact-delete-dialog.component';
export * from './contact-detail.component';
export * from './contact.component';
export * from './contact.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contact/index.ts